// extracted by mini-css-extract-plugin
module.exports = {"colorGrayLight":"#718096","colorPinkMagenta":"#d53f8c","colorPurpleLight":"#805ad5","colorBlue":"#3182ce","colorTeal":"teal","colorOrange":"#e86c00","colorYellow":"#ffc800"};